(() => {
  'use strict';
  const key = Symbol.for('seldravinpack.faq.initialize');
  if (window[key]) { window[key](document); return; }
  const instances = new Map();
  function create(root) {
    const controller = new AbortController();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const single = root.dataset.singleOpen === 'true';
    const listen = (node, event, fn) => node.addEventListener(event, fn, { signal: controller.signal });
    const items = [...root.querySelectorAll('[data-faq-item]')].map(details => ({ details, summary: details.querySelector('summary'), expanded: details.open, animation: null }));
    function reflect(item) {
      item.details.dataset.expanded = String(item.expanded);
      item.summary.setAttribute('aria-expanded', String(item.expanded));
    }
    function settle(item) {
      const animation = item.animation;
      item.animation = null;
      if (animation) { animation.onfinish = null; animation.cancel(); }
      item.details.open = item.expanded;
      reflect(item);
    }
    function setOpen(item, open, immediate = false) {
      if (open && single) items.forEach(other => { if (other !== item && other.expanded) setOpen(other, false, immediate); });
      const start = item.details.getBoundingClientRect().height;
      item.expanded = open;
      settle(item);
      if (immediate || reduced.matches || typeof item.details.animate !== 'function') return;
      // Measure the natural target before holding the details element open to animate.
      const target = item.details.getBoundingClientRect().height;
      item.details.open = true;
      const animation = item.details.animate({ height: [`${start}px`, `${target}px`] }, { duration: 260, easing: 'cubic-bezier(.22,.61,.36,1)' });
      item.animation = animation;
      animation.onfinish = () => { if (item.animation === animation) settle(item); };
    }
    items.forEach(item => {
      reflect(item);
      listen(item.summary, 'click', event => { event.preventDefault(); setOpen(item, !item.expanded); });
      // Preserve external/native changes when no animation is holding details open.
      listen(item.details, 'toggle', () => {
        if (item.animation) return;
        if (item.expanded !== item.details.open) setOpen(item, item.details.open, true);
      });
    });
    listen(reduced, 'change', () => items.forEach(settle));
    listen(window, 'resize', () => items.forEach(settle));
    listen(root, 'shopify:block:select', event => {
      const item = items.find(item => item.details.dataset.blockId === String(event.detail?.blockId));
      if (item) setOpen(item, true, true);
    });
    return { destroy() { controller.abort(); items.forEach(item => { settle(item); item.summary.removeAttribute('aria-expanded'); }); } };
  }
  function initialize(scope) {
    const roots = [...scope.querySelectorAll('[data-packaging-faq]')];
    if (scope.matches?.('[data-packaging-faq]')) roots.unshift(scope);
    roots.forEach(root => { if (!instances.has(root)) instances.set(root, create(root)); });
  }
  function remove(root) { instances.get(root)?.destroy(); instances.delete(root); }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { [...instances.keys()].forEach(root => { if (event.target === root || event.target.contains(root)) remove(root); }); });
  new MutationObserver(() => { [...instances.keys()].forEach(root => { if (!root.isConnected) remove(root); }); }).observe(document.documentElement, { childList: true, subtree: true });
  window[key] = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
